import { useQuery } from 'apollo-3';

import { useClassroomContext } from 'Context/ClassroomContext';
import { classroomCourse } from 'GraphQL/query/Classroom.query';

const useClassroomCourseData = ({ ...props }) => {
  const { classroomCourseId, classroomTimeId } = useClassroomContext();

  const { data, loading, error } = useQuery(classroomCourse, {
    variables: {
      classroomCourseId,
      classroomTimeId,
      includeClassroomTime: classroomTimeId ? true : false,
    },
    ...props,
  });

  return {
    data,
    isClassroomTrialMode: data?.classroomCourse?.classroomMode === 'TRIAL',
    loading,
    error,
  };
};

export default useClassroomCourseData;
